const gallery = [
  {
    src: "/gallery/1.jpeg",
    // caption: "Instalasi CCTV di area perumahan",
  },
  {
    src: "/gallery/2.jpeg",
  },
  {
    src: "/gallery/3.jpeg",
  },
  {
    src: "/gallery/4.jpeg",
  },
  {
    src: "/gallery/5.jpeg",
  },
  {
    src: "/gallery/6.jpeg",
  },
  {
    src: "/gallery/7.jpeg",
  },
  {
    src: "/gallery/8.jpeg",
  },
  {
    src: "/gallery/9.jpeg",
  },
  {
    src: "/gallery/10.jpeg",
  },
  {
    src: "/gallery/11.jpeg",
  },
  {
    src: "/gallery/12.jpeg",
  },
];

export default gallery;
